// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CanaryPageHeaderTsx from "./CanaryPageHeader.tsx";

let contentOffset = CanaryPageHeaderTsx.pageHeaderContentOffset;

let make = CanaryPageHeaderTsx.CanaryPageHeaderSiblingNavigation;

let SiblingNavigation = {
  make: make
};

let make$1 = CanaryPageHeaderTsx.CanaryPageHeader;

export {
  contentOffset,
  SiblingNavigation,
  make$1 as make,
}
/* contentOffset Not a pure module */
